<template>
    <hts-drawer
        v-model="visible"
        :title="$t('labels.addContact')"
        :rules="rulesCooperatorContact"
        :submit="submit"
        @close="close">
        <hts-card :title="$t('labels.generalInformation')">
            <hts-form-input
                v-model="formData.fullName"
                :label="$t('labels.fullName')"
                required
                prop="fullName"
                name="fullName"/>
            <hts-form-phone
                v-model="formData.phone"
                :label="$t('labels.phone')"
                required
                prop="phone"
                name="phone"
                @updateCode="(val) => (formData.phone.code = val)" />
            <hts-form-input
                v-model="formData.email"
                :label="$t('labels.email')"
                required
                prop="email"
                name="email"/>
            <hts-form-input
                v-model="formData.office"
                :label="$t('labels.office')"
                required
                prop="office"
                name="office"/>
            <hts-form-select
                v-model="formData.department"
                :label="$t('labels.department')"
                required
                :items="departments"
                key-id="key"
                key-label="value"
                prop="department"
                name="department"
                @change="handleUpdateDepartment" />
            <hts-select-node
                v-if="formData.department === 'LOGISTIC'"
                v-model="formData.warehouses"
                :label="$t('labels.nodeModule.warehouse')"
                key-label="locationName"
                :multiple="true"
                type="WAREHOUSE"/>
            <hts-form-date
                v-model="formData.birthday"
                :label="$t('labels.birthday')"
                type="date"
                name="birthday"
                prop="birthday" />
            <hts-form-input
                v-model="formData.description"
                :label="$t('labels.description')"
                name="description"
                prop="description" />
        </hts-card>
    </hts-drawer>
</template>

<script setup lang="ts">
import data from '../ignore/data'
const { departments } = data()

const rulesCooperatorContact = {
  fullName: 'required',
  phone: 'required',
  email: 'required|regexEmail',
  office: 'required',
  department: 'required'
}
const cooperatorId = ref('')
const visible = ref(false)

const resetForm = () => {
  formData.value = {
    cooperator: '',
    fullName: '',
    phone: {
      countryCode: '',
      phone: '',
      code: ''
    },
    email: '',
    office: '',
    department: '',
    birthday: '',
    warehouses: [],
    description: ''
  }
}
const formData = ref({
  cooperator: '',
  fullName: '',
  phone: {
    countryCode: '',
    phone: '',
    code: ''
  },
  email: '',
  office: '',
  department: '',
  birthday: '',
  warehouses: [],
  description: ''
})
const close = () => {
  resetForm()
  visible.value = false
}

const emits = defineEmits(['update:show', 'close', 'actionAddCompanyUser', 'refreshTables', 'newContactCooperator'])

const open = (id: string) => {
  cooperatorId.value = id
  visible.value = true
  formData.value.phone = {
    countryCode: 'Vietnam +84',
    phone: '',
    code: '+84'
  }
}
defineExpose({
  open
})

const handleUpdateDepartment = () => {
  formData.value.warehouses = []
}

const submit = async () => {
  const api = {
    url: '/partner/contact/cooperatorId/create',
    method: 'post'
  }
  const data: any = await $api(api, { uriParams: { cooperatorId: cooperatorId.value }, body: formData.value })
  const resData = data?.data?.value
  if (resData && resData.success) {
    if (resData.success) {
      resetForm()

      process.client && $toast().success($t('labels.createContactSuccess'))
      close()
      emits('refreshTables')
      emits('newContactCooperator', resData.data)
    }
  }
}
</script>
